// extracted by mini-css-extract-plugin
export default {"footerWrap":"Footer_footerWrap__G5uzR","footer":"Footer_footer__fj9MH","contactUs":"Footer_contactUs__FxO2n","text":"Footer_text__5TjXb","btn":"Footer_btn__NZ6WT"};